import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseComponent } from '@macs-frontend/core';
import { FormControlState } from 'ngrx-forms';

@Component({
  selector: 'md-notes',
  templateUrl: './notes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NotesComponent),
      multi: true,
    },
  ],
})
export class NotesComponent
  extends BaseComponent
  implements OnInit, ControlValueAccessor
{
  @Input() notes1Control?: FormControlState<string | null | undefined>;
  @Input() label1 = 'Notes';
  @Input() subLabel1 = '(optional)';

  @Input() notes2Control?: FormControlState<string | null | undefined>;
  @Input() label2 = 'Notes';
  @Input() subLabel2 = '(optional)';

  // @ts-expect-error
  _note: string;
  get note(): string {
    return this._note;
  }
  set note(text: string) {
    this.onChangeCallback(text);
    this._note = text;
  }

  onChangeCallback = (_: any) => {};

  ngOnInit(): void {}

  registerOnChange(fn: (_: any) => void) {
    this.onChangeCallback = fn;
  }

  registerOnTouched() {}

  writeValue(note: string) {
    this.note = note;
    this.cdr.markForCheck();
  }

  constructor(readonly cdr: ChangeDetectorRef) {
    super();
  }
}
